import { AppPageHeader1 } from '@juvare/common-web-ui/AppPageHeader1';
import { LayoutRows2 } from '@juvare/common-web-ui/LayoutRows2';
import { SectionLink, SectionWithLinks } from '@juvare/common-web-ui/SectionWithLinks';
import { Box } from '@mui/material';
import uniq from 'lodash/uniq';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useConfigurationPages } from './hooks';

export const ConfigurationsPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <LayoutRows2
            row1={<AppPageHeader1 title={t('appHeader.settings.configurations')} />}
            row2={<ClassifierMenu />}
            fullHeightRow='row2'
            row2Scrollable={true}
        />
    );
};

interface Group {
    label: string;
    links: SectionLink[];
}

const ClassifierMenu: React.FC = () => {
    const navigate = useNavigate();
    const configurationPages = useConfigurationPages();
    const groupNames = uniq<string>(configurationPages.map((page) => page.groupLabel)).sort();
    const groups = groupNames.reduce<Group[]>((acc, groupName) => {
        const sortedLinks = configurationPages
            .filter((page) => page.groupLabel === groupName)
            .map((page) => {
                const href = '/configurations/' + page.path;
                return {
                    href: href,
                    label: page.label,
                    onClick: () => {
                        navigate(href);
                    },
                };
            });
        acc.push({ label: groupName, links: sortedLinks });
        return acc;
    }, []);

    return (
        <Box p={2}>
            {groups.map((group) => (
                <SectionWithLinks key={group.label} title={group.label} links={group.links} />
            ))}
        </Box>
    );
};
